<div class="d-flex align-items-center">
  <div class="user-menu">
    <ul class="user-menu__items">
      <ng-container *ngFor="let item of menuItems">
        <li
          *ngIf="item.visible | observablePipe | async"
          [class.disabled]="item.disabled | observablePipe | async"
          (click)="executeCommand(item)">
          <div class="menu-item">
            <i [className]="item?.icon$ | observablePipe | async"></i>
          </div>

          <ng-container *ngIf="item.notificationBadgeOptions | observablePipe | async as options">
            <cap-notification-badge [showBadge]="!!options.showBadge" [options]="options"> </cap-notification-badge>
          </ng-container>

        </li>
      </ng-container>
    </ul>
  </div>
</div>
